import { createStore } from 'vuex'
import auth from './modules/auth'
import master from './modules/master'
import sidebar from './modules/sidebar'
import notifications from './modules/notifications'
import receipts from './modules/receipts'
import history from './modules/history'
import loading from './modules/loading'

export default createStore({
  state: {
    sidebarCollapsed: false,
  },
  getters: {
    sidebarCollapsed: state => state.sidebarCollapsed,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
  },
  actions: {},
  modules: {
    auth,
    master,
    sidebar,
    notifications,
    receipts,
    history,
    loading,
  }
})

